import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import withTranslateProvider from 'src/hoc/with-translate-provider'
import HeadMetaTags from '~/components/HeadMetaTags'
import AllFeaturesContainer from '~/features/all-features'
import en_all_features from '../../public/locales/en/all-features.json'
import jp_all_features from '../../public/locales/ja/all-features.json'
// import jsonLd from '../../public/schema.json'

const AllFeaturesPage: FC = () => {
  const { t } = useTranslation()

  return (
    <>
      {/* <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      /> */}
      <HeadMetaTags
        title={t('meta:ats:meta_title')}
        description={t('meta:ats:meta_description')}
      />
      <AllFeaturesContainer />
    </>
  )
}

export default withTranslateProvider(AllFeaturesPage, {
  en: { all_features: en_all_features },
  ja: { all_features: jp_all_features }
})
